import React from "react";
import {FormPageLayout} from "../components/layout/FormPageLayout";
import {NAVIGATION_BAR_HEIGHT} from "../designSystem/tokens/spacing";

const NotFoundPage = () => (
  <FormPageLayout
    height={NAVIGATION_BAR_HEIGHT.LARGE}
    body={
      <div className="m-auto text-center">
        <h1 className="mb-2">
          404 - Page Not Found
        </h1>
        <p>
          找不到您要的頁面
        </p>
      </div>
    }
  />
);

export default NotFoundPage;